export default __webpack_public_path__ + "8b3245860c25169e307269767b3edeb5.png";